module.exports = __webpack_public_path__ + "img/comfort_book.97c58fb3.jpg";